import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { Col } from "react-bootstrap";
import { Api } from "../../utils/api";
import { MaterialSelect } from "../../components/select-field.component";
import { TextField } from "formik-material-ui";
import { CheckboxWithLabel } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

const plansOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/plans")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const PaymentFilterForm = ({ onChange, searchValues }) => (
  <Col>
    <Formik
      initialValues={{ ...searchValues }}
      onSubmit={handleSubmitting(onChange)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      render={({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Field
              name="payment_at_gte"
              label="Data cobrança >="
              type="date"
              variant="outlined"
              margin="normal"
              component={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={setFieldValue}
              value={"" + values.payment_at_gte}
            />
            <Field
              name="payment_at_lte"
              label="Data cobrança <="
              type="date"
              variant="outlined"
              margin="normal"
              component={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={setFieldValue}
              value={"" + values.payment_at_lte}
            />
            <MaterialSelect
              name="plan_id"
              placeholder="plan_id"
              label="Plano"
              value={"" + values.plan_id}
              onBlur={setFieldTouched}
              onChange={setFieldValue}
              optionsFetcher={plansOptionsPromise}
            />
            <Field
              name="payments_processed"
              Label={{ label: "Apenas cobranças processadas" }}
              component={CheckboxWithLabel}
              onChange={setFieldValue}
              value={"" + values.payments_processed}
            />
            <Button variant="contained" type="submit" size="small">
              Filtrar
            </Button>
          </form>
        );
      }}
    />
  </Col>
);
